import Component from './FolderBar';
import ComponentContainer, { OwnProps } from './FolderBar.container';

export type Props = OwnProps;

export default ComponentContainer(Component) as React.ComponentType<OwnProps>;
